@import '~style-sheet-helpers/core.less';
@import (reference) '../../../products/product-details/style.module.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.grid {
  flex-grow: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.header {
  display: grid;
  grid-template-columns: minmax(auto, 350px) 140px 1fr;
}

.header-cell {
  background-color: @product-page--header--background-color;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  border: 1px solid @product-page--header--border-color;
  border-left: none;
  border-right: 1px solid @product-page--header--border-color;
  padding-left: 10px;
  text-align: left;

  &.header-cell-active {
    font-weight: 700;
  }
}

.reporting-category-container {
  display: grid;
  grid-template-columns: minmax(auto, 350px) 140px 1fr;
  grid-template-rows: repeat(auto-fill, 30px);
  font-size: 14px;
  direction: initial;
  width: auto;
  overflow: auto;

  .item-cell {
    width: inherit;
    padding: 5px 10px;
    border-bottom: 1px solid @product-page--header--border-color;
    text-overflow: ellipsis;
    overflow: hidden;
    height: 30px;
    display: flex;
    align-items: center;
  }
}

.caret {
  width: 30px;
  height: 30px;
  fill: @product-page--header-icon--icon-color;
  transform: scale(0.27);
  float: right;

  &.caret-active {
    fill: @product-page--header-icon--active--icon-color;
  }

  &.caret-up {
    transform: rotate(180deg) scale(0.27);
  }
}

.popover-title {
  margin: 0;
  padding: 8px 10px;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  background-color: @product-page--popover-title--background-color;
  border-bottom: 1px solid @product-page--popover-title--border-color;
  border-radius: 5px 5px 0 0;
}

.popover-body {
  padding: 9px 10px;
  display: flex;
  .popover-body-input {
    margin-bottom: 10px;
    height: 30px;
    width: 67%;
    resize: both;
    order: 1;
    flex: 1 0 auto;
    Input {
      .input-border-base-style();
    }
  }
  .popover-buttons {
    display: inline;
    justify-content: flex-start;
    order: 2;
    padding-left: 10px;
    button {
      background-color: @product-page--popover-button--background-color;
      border: 1px solid @product-page--popover-button--border-color;
      border-radius: 4px;
      padding: 0;
      margin-bottom: 10px;
      margin-right: 10px;
      &:hover,
      &:focus {
        background-color: @product-page--popover-button--hover--background-color;
      }
      &.save {
        color: @product-page--save--text-color;
        background-color: @product-page--save--background-color;
        border-color: transparent;
        svg {
          fill: @product-page--save--icon-color;
        }
        &:hover,
        &:focus {
          background-color: @product-page--save--hover--background-color;
        }
      }

      svg {
        transform: scale(0.6);
      }
    }
  }
}

.modal {
  width: 500px;
}

.modal-body {
  background-color: @product-page--modal-body--background-color;
}

.warning {
  margin: 20px;
  height: 50px;
}

.saveEditButton {
  margin-right: 15px;
}

.nameInput {
  width: 95%;
  height: 25px;
  Input {
    .input-border-base-style();
  }
}

.error {
  padding: 0 10px 10px;
  font-size: 14px;
  color: @product-page--modal-status--error--text-color;
}

.tooltip-text {
  max-width: 300px;
}

.icon-wrapper {
  height: 30px;
  width: 20px;
  min-width: 20px;
  align-self: center;
  position: relative;
  padding-top: 7px;
  margin-left: 2px;
}

.icon {
  height: 16px;
  width: 18px;
  vertical-align: middle;
  fill: @product-page--grid-row-icon--error--fill-color;
}
